import React, { PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import FullWidthRegion from './FullWidthRegion';
import ThumbnailList from './ThumbnailList';
import Statement from './Statement';
import styles from './Work.css';
import { workShape } from '../lib/shapes';

function Work(props, context) {
  const { work, currentImageIndex } = props;
  const currentImageInfo = work.images[currentImageIndex];
  const base = `/works/${work.id}`;

  const images = work.images.map((image, index) => ({
      // Links to the first image should exclude the image index.
      // URL index starts a 1, not zero.
    url: (index === 0) ? base : `${base}/${index + 1}`,
    imageInfo: image,
  }));
  const hasDetailImages = images.length > 1;

  let wrapperClassName = 'image-wrapper';
  let imageStyles = {};

  // Apply portrait styles and calculate max-height:
  if (currentImageInfo.orientation === 'portrait') {
    wrapperClassName += ' portrait';
    const width = currentImageInfo.width;
    const height = currentImageInfo.height;
    const maxHeight = Math.round((height / width) * 1100);
    imageStyles = { maxHeight };
  }

  return (
    <div>
      <FullWidthRegion seamless>
        <div styleName={wrapperClassName}>
          <img alt={props.work.title} onLoad={props.onWorkLoad} styleName="image" src={currentImageInfo.src} style={imageStyles} />
        </div>
      </FullWidthRegion>

      <FullWidthRegion>
        <h1 styleName="title">{ work.title }</h1>
        <p styleName="details">
          <span styleName="year">{ work.year }</span>
          <span styleName="dimensions">{ work.dimensions }</span>
          <span
            styleName="medium"
            dangerouslySetInnerHTML={{ __html: work.medium }}
          />
        </p>

        {
          hasDetailImages ?
            <div styleName="thumbnails">
              <ThumbnailList images={images} />
            </div> :
            null
        }

        <Statement text={work.statement} dropCap={false} />
      </FullWidthRegion>
    </div>
  );
}

Work.propTypes = {
  work: workShape.isRequired,
  currentImageIndex: PropTypes.number,
  onWorkLoad: PropTypes.func,
};

export default CSSModules(Work, styles, {
  errorWhenNotFound: false,
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./application/js/components/Work.js